import { CompanyRegistry } from './CompanyRegistry';

let companyRegistryInstance: CompanyRegistry | null = null;

/**
 * Retrieves the singleton instance of CompanyRegistry.
 * @returns The singleton instance of CompanyRegistry.
 */
export function getCompanyRegistry(): CompanyRegistry {
  if (!companyRegistryInstance) {
    companyRegistryInstance = new CompanyRegistry();
  }
  return companyRegistryInstance;
}

/**
 * Resets the singleton instance (for testing purposes only).
 * Do not use in application code.
 */
export function resetCompanyRegistry(): void {
  companyRegistryInstance = null;
}
